var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.5V8.66667H1V10.7833L3.46667 8.31667L4.18333 9.03333L1.71667 11.5H3.83333V12.5H0ZM8.16667 12.5V11.5H10.2833L7.83333 9.05L8.55 8.33333L11 10.7833V8.66667H12V12.5H8.16667ZM3.45 4.66667L1 2.21667V4.33333H0V0.5H3.83333V1.5H1.71667L4.16667 3.95L3.45 4.66667ZM8.55 4.66667L7.83333 3.95L10.2833 1.5H8.16667V0.5H12V4.33333H11V2.21667L8.55 4.66667Z",
    fill: "#3A74F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpand);
export default __webpack_public_path__ + "static/media/icon-expand.723bdead6fddb6d12a68af224d4a2df4.svg";
export { ForwardRef as ReactComponent };